import { useState, useCallback } from "react";

export const usePrivacyConsent = () => {
    const [privacyConsent, setPrivacyConsent] = useState(false);
    const [privacyError, setPrivacyError] = useState(null);

    const validatePrivacyConsent = useCallback(() => {
        if (!privacyConsent) {
            setPrivacyError("You must accept the privacy terms to submit the form");
            return false;
        }

        setPrivacyError(null);
        return true;
    }, [privacyConsent]);

    const handlePrivacyConsentChange = useCallback((checked) => {
        setPrivacyConsent(checked);
        if (checked) {
            setPrivacyError(null);
        }
    }, []);

    const resetPrivacyConsent = useCallback(() => {
        setPrivacyConsent(false);
        setPrivacyError(null);
    }, []);

    return {
        privacyConsent,
        privacyError,
        validatePrivacyConsent,
        handlePrivacyConsentChange,
        resetPrivacyConsent,
    };
};
